import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export const BtnContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '10px',
});

export const KeyWordBtn = styled(Button)({
  border: '1px solid #1D6FBB',
  borderRadius: '8px',
  padding: '6px 16px',
  marginRight: '15px',
  fontWeight: '600',
});
